module.exports = __webpack_public_path__ + "img/ref_1.191dab92.png";